import _ from 'lodash';

const { text } = d3;
const { csvParseRows, csvParse, csvFormatRows } = d3;

const externalCSSPath = process.env.BASE_URL === '/' ? `${process.env.BASE_URL}css` : process.env.BASE_URL;
const allowedExternalCSS = [
    'https://fonts.googleapis.com/icon?family=Material+Icons'
];

const externalCSS = _.filter(document.styleSheets,
    (sheet) => sheet.href && !sheet.href.includes(externalCSSPath) && !_.includes(allowedExternalCSS, sheet.href));


/* eslint-disable no-param-reassign */
export function toggleExternalCSS(off = true) {
    _.forEach(externalCSS, (sheet) => {
        // console.log(sheet.href, sheet.href.includes(externalCSSPath))
        sheet.disabled = off;
    });
}

export function nextTick(n = 0, val) {
    return new Promise(resolve => setTimeout(() => resolve(val), n));
}

/**
 * Applies a css class for the PDF,
 * removes all external styles and then calls the resize so that the
 * dynamically resized SVGs are drawn at any new sizes set in the CSS for pdf
 */
export async function styleForPrint(print = true, { cssClass = 'pdf' } = {}) {
    const containerSelector = '#community-profiles-viz';
    const containerSel = d3.selectAll(containerSelector);
    containerSel.classed(cssClass, print);
    // toggleExternalCSS(print);
    await nextTick();
    window.dispatchEvent(new Event('resize'));
}

/**
 * Replacement for d3.csv that camel cases the header row before parsing
 *
 * i.e.: a file like: "Column one,Column TWO\na,b"
 *
 * gets parsed to: {columnOne: 'a', columnTwo: 'b'}
 */
export async function camelCaseCsv(input, init) {
    const body = await text(input, init);

    const [headerString, ...data] = body.split('\n');
    const [headers] = csvParseRows(headerString);
    const camelCasedHeaders = headers.map(_.camelCase);
    const camelCasedHeaderString = csvFormatRows([camelCasedHeaders]);

    return csvParse([camelCasedHeaderString, ...data].join('\n'));
}

export function isIE() {
    const ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
    const msie = ua.indexOf('MSIE '); // IE 10 or older
    const trident = ua.indexOf('Trident/'); // IE 11

    return (msie > 0 || trident > 0);
}
